// extracted by mini-css-extract-plugin
export var wrapper = "bio-module--wrapper--343Bp";
export var outerWrapper = "bio-module--outerWrapper--3qGGE";